import React from 'react'
import {Tree, message} from 'antd'
import type {DataNode} from 'antd/es/tree'
import {useIntl} from 'react-intl'
import './CanvasViewEditor.less'
import './CanvasViewEditorData.less'
import {FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import * as Icons from '@fortawesome/free-solid-svg-icons'
import * as IconsRegular from '@fortawesome/free-regular-svg-icons'
import {LinkOutlined} from '@ant-design/icons'

export type CanvasViewEditorDataSectionProps = {
  treeDataElements: DataNode[]
  onSelectElement: (selectedKeys: [], info: {}) => void
  compositionTreeExpandedKeys: (string | number)[]
  setCompositionTreeExpandedKeys: (keys: (string | number)[]) => void
  selectedKeys: (string | number)[]
  sectionType: 'planted-plants' | 'solitarius-templates' | 'other-elements'
  name: string
  description: string
  icon: Icons.IconDefinition | IconsRegular.IconDefinition
}

export function CanvasViewEditorDataSection({
  treeDataElements,
  onSelectElement,
  compositionTreeExpandedKeys,
  setCompositionTreeExpandedKeys,
  selectedKeys,
  sectionType,
  name,
  description,
  icon,
}: CanvasViewEditorDataSectionProps) {
  const [messageApi, contextHolder] = message.useMessage()
  const intl = useIntl()

  return (
    <div className={`canvas-data__section canvas-data__section--${sectionType}`}>
      <div className="canvas-data__section__header">
        <div className="canvas-data__section__header__icon">
          <Icon icon={icon as any} />
        </div>
        <div className="canvas-data__section__header__text">
          <div className="canvas-data__section__header__text__name">
            {intl.formatMessage({id: name})}
          </div>
          {sectionType === 'planted-plants' && (
            <div className="canvas-data__section__header__text__description">
              ({description ? intl.formatMessage({id: description}) : ''})
            </div>
          )}
          {sectionType === 'solitarius-templates' && (
            <div className="canvas-data__section__header__text__description">
              ({description ? intl.formatMessage({id: description}) : ''} <LinkOutlined />)
            </div>
          )}
        </div>
      </div>
      <div className="canvas-data__section__data">
        {treeDataElements.length > 0 ? (
          <Tree
            multiple
            defaultExpandAll={false}
            onSelect={onSelectElement}
            expandedKeys={compositionTreeExpandedKeys}
            onExpand={(keys, _info) => setCompositionTreeExpandedKeys(keys)}
            selectedKeys={selectedKeys}
            treeData={treeDataElements}
            showIcon
            className="elements-tree"
          />
        ) : (
          <span className="canvas-data__section__data__empty">
            {intl.formatMessage({id: `noEntries`})}
          </span>
        )}
      </div>
    </div>
  )
}
